import { ReactGA } from "../analytics";
import {
  FETCH_STOCK,
  UPDATE_COMPANY_SEARCH,
  RESET_COMPANY_SEARCH,
  FETCH_TRENDING,
  SHOW_FORGOT_PASSWORD,
  HIDE_FORGOT_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  LOGIN_SUCCESS,
  LOGOUT_ACTION,
  SHOW_LOGIN,
  HIDE_LOGIN,
  SHOW_PREFERENCES,
  HIDE_PREFERENCES,
  CHANGE_PASSWORD_WITH_TOKEN_SUCCESS,
  REGISTER_SUCCESS,
  FETCH_PROFILE,
  FETCH_WATCHLIST,
  ADD_WATCHLIST,
  REMOVE_WATCHLIST,
  CLEAR_WATCHLIST,
  CLEAR_MESSAGE,
  UPDATE_FILTER,
  UPDATE_MOST_EXPENSIVE,
  CHANGE_EMAIL_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  FETCH_ALERT_CONFIGS,
  UPDATE_ALERT_CONFIG,
  CREATE_ALERT_CONFIG,
  DELETE_ALERT_CONFIG,
  FETCH_STOCK_PENDING,
} from "../actions/index";

export const StockReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_STOCK_PENDING:
      return {};
    case FETCH_STOCK:
      return { ...action.payload.data, active: "real_time" };
    default:
      return state;
  }
};

export const CompanySearchReducer = (state = [], action) => {
  switch (action.type) {
    case UPDATE_COMPANY_SEARCH:
      return action.payload.data.results;
    case RESET_COMPANY_SEARCH:
      return [];
  }
  return state;
};

export const TrendingReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_TRENDING:
      return { ...action.payload.data };
    default:
      return state;
  }
};

export const AuthReducer = (
  state = {
    authenticated: false,
    showLogin: false,
    showForgotPassword: false,
    username: "",
    id: "",
    receiveEmail: false,
    showPreferences: false,
  },
  action
) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      localStorage.setItem("token", action.payload);
      return { ...state, authenticated: true, showLogin: false };
    case LOGOUT_ACTION:
      ReactGA.set({ userId: undefined });
      localStorage.removeItem("token");
      return {
        ...state,
        authenticated: false,
        showLogin: false,
        username: "",
        id: "",
        subscribed: false,
        subscriptionLevel: undefined,
        readableSubscriptionLevel: undefined,
      };
    case SHOW_LOGIN:
      ReactGA.set({ userId: undefined });
      localStorage.removeItem("token");
      return {
        ...state,
        authenticated: false,
        showLogin: true,
        username: "",
        id: "",
      };
    case SHOW_FORGOT_PASSWORD:
      ReactGA.set({ userId: undefined });
      localStorage.removeItem("token");
      return {
        ...state,
        authenticated: false,
        showLogin: false,
        showForgotPassword: true,
        username: "",
        id: "",
      };
    case HIDE_FORGOT_PASSWORD:
      return { ...state, showForgotPassword: false };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        showForgotPassword: false,
        showChangePasswordWithToken: true,
      };
    case CHANGE_PASSWORD_WITH_TOKEN_SUCCESS:
      return { ...state, showChangePasswordWithToken: false };
    case FETCH_PROFILE:
      ReactGA.set({ userId: action.payload.id });
      return {
        ...state,
        username: action.payload.username,
        id: action.payload.id,
        subscribed: action.payload.subscribed,
        subscriptionLevel: action.payload.subscriptionLevel,
        readableSubscriptionLevel: action.payload.readableSubscriptionLevel,
        fullExportLink: action.payload.fullExportLink,
        receiveEmail: action.payload.receiveEmail,
      };
    case HIDE_LOGIN:
      return { ...state, showLogin: false };
    case HIDE_PREFERENCES:
      return { ...state, showPreferences: false };
    case SHOW_PREFERENCES:
      return { ...state, showPreferences: true };
    default:
      return state;
  }
};

export const WatchlistReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_WATCHLIST:
      if (action.payload.data.watchlist) {
        return [...action.payload.data.watchlist];
      } else if (action.payload.data.hasOwnProperty("watchlist")) {
        return [];
      }
      return state;

    case CLEAR_WATCHLIST:
      return [];
    default:
      return state;
  }
};

export const alertReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_ALERT_CONFIGS:
      if (action.payload.data) {
        return {
          ...state,
          configs: action.payload.data,
          remaining: action.payload?.meta?.remaining_alert_configs,
        };
      }
      return state;
    case UPDATE_ALERT_CONFIG:
      if (action.payload.data) {
        const existingConfigs = state.configs;
        const index = existingConfigs.findIndex(
          (config) => config.id === action.payload.data.id
        );
        existingConfigs.splice(index, 1, action.payload.data);
        return {
          ...state,
          configs: [...existingConfigs],
          remaining: action.payload.meta.remaining_alert_configs,
        };
      }
      return state;
    case CREATE_ALERT_CONFIG:
      if (action.payload.data) {
        return {
          ...state,
          configs: [...(state.configs ?? []), action.payload.data],
          remaining: action.payload.meta.remaining_alert_configs,
        };
      }
      return state;
    case DELETE_ALERT_CONFIG:
      if (action.payload) {
        return {
          ...state,
          configs: state.configs.filter(
            (config) => config.id !== action.payload
          ),
          remaining: state.remaining + 1,
        };
      }
    default:
      return state;
  }
};

export const MessageReducer = (state = null, action) => {
  switch (action.type) {
    case REGISTER_SUCCESS:
      return {
        text:
          "Registration successful! In order to login you will need to confirm the email address you signed up with. Check your email for a link!",
        type: "success",
      };
    case LOGIN_SUCCESS:
      return { text: "Welcome!", type: "success" };
    case ADD_WATCHLIST:
      return {
        text: `Added ${action.payload} to your watchlist`,
        type: "info",
      };
    case REMOVE_WATCHLIST:
      return {
        text: `Removed ${action.payload} from your watchlist`,
        type: "info",
      };
    case CREATE_ALERT_CONFIG:
      return {
        text: `Added an alert for ${action.payload.data.symbol}`,
        type: "info",
      };
    case CHANGE_EMAIL_SUCCESS:
      return { text: "Email successfully changed", type: "success" };
    case CHANGE_PASSWORD_SUCCESS:
      return { text: "Password successfully changed", type: "success" };
    case RESET_PASSWORD_SUCCESS:
      return {
        text:
          "A reset password link will be sent to the account associated with your email if it exists.",
        type: "success",
      };
    case CLEAR_MESSAGE:
      return null;
    default:
      return state;
  }
};

export const FilteredStocksReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_FILTER:
      return {
        data: action.payload.data,
        currentPage: action.payload.currentPage,
        hasNextPage: action.payload.meta.has_next_page,
        hasPreviousPage: action.payload.currentPage > 0,
      };
    default:
      return state;
  }
};
